export const isMultiSelectValue = <Value, IsMulti extends boolean>(value: Value | Value[], isMulti?: IsMulti): value is Value[] => {
    return Boolean(isMulti);
};
